import api from '../api.js'
import EET from '../vendor/eet.js'

import { GAP_GIFT_CARD } from '../settings.js'

export default {

  init () {
    this.et = new EET()
  },

  track (path, id) {
    let panicCounter = 10

    api.get(`tracking/${id}/track/`)

    return new Promise(resolve => {
      const poll = setInterval(() => {
        // We try to wait for GA, but only a few times
        panicCounter--

        if (panicCounter < 0) {
          clearInterval(poll)
          return
        }

        // check for ga
        if (typeof window === 'undefined' || !window.ga) {
          return
        }

        ga('send', 'pageview', path)

        // ga is available
        clearInterval(poll)
        resolve()
      }, 100)
    })
  },

  eetInit (section) {
    this.et.init(section, [])
    this.eetSection(section)
  },

  eetSection (section) {
    this.et.bookingSectionClick(section, [])
  },

  eetGapListView () {
    this.et.gapListView()
  },

  eetEventTeaserImpression (position, teaser) {
    this.et.eventTeaserImpression(position, [teaser])
  },

  eetEventTeaserClick (position, teaser) {
    this.et.eventTeaserClick(position, [teaser])
  },

  eetEventProductView (product) {
    this.et.eventProductView([product])
  },

  eetCheckoutUpsellView (products) {
    this.et.checkoutUpsellView(products)
  },

  eetCheckoutUpsellViewDetail (product) {
    this.et.checkoutUpsellViewDetail([product])
  },

  eetCheckoutUpsellAddToCart (products) {
    for (const pid in products) {
      this.et.checkoutUpsell_addToCart([products[pid]])
    }
  },

  eetGapSelected () {
    this.et.gapSelected()
  },

  eetCheckoutOverview () {
    this.et.checkoutOverview()
  },

  eetCheckoutPersonalDataView () {
    this.et.checkoutPersonalData()
  },

  eetCheckoutPersonalDataReturning (returning) {
    this.et.checkoutPersonalData_Returning(returning)
  },

  eetCheckoutPersonalDataViewNewsletter (newsletter) {
    this.et.checkoutPersonalData_Newsletter(newsletter)
  },

  eetCheckoutPayment (paymentMethod) {
    this.et.checkoutPayment(paymentMethod)
  },

  eetUpdateCart (state) {
    this.et.updateCart(this.makeCart(state))
  },

  eetTrackUpdateCart (state) {
    this.eetUpdateCart(state)
  },

  eetCheckoutError () {
    this.et.checkoutConfirmation(false)
  },

  eetConfirmCheckout (bookingId) {
    this.et.checkoutConfirmation(true, bookingId)
  },

  // We have no bookingId, only a barcode
  eetReservationCancelled (bookingId) {
    this.et.ticketCancelled(bookingId)
  },

  makeProduct (id, type, state, list = null, position = null) {
    let name = ''
    let variant = ''
    let category = ''
    let tid = ''
    let taxRate = 0
    let articles = {}
    let gap = null
    let date = null
    let price = 0
    let quantity = 0

    if (type === 'ticket') {
      name = 'Ticket'
      articles = state.cart.tickets.articles[id]
      variant = state.articles[id]?.text_de
      gap = state.cart.tickets.gap
      date = state.cart.tickets.date
      quantity = articles.count

      taxRate = state.articles[id]?.tax_rate
      category = 'Tickets/Regular'
      tid = `wt.${id}`
      price = articles.discounted_price

      if (gap === GAP_GIFT_CARD) {
        name = 'Geschenkgutschein Ticket'
        category = 'Tickets/Regular/Gift Certificates'
        tid = `wg.${id}`
      }
    } else if (type === 'voucher') {
      articles = state.cart.vouchers.articles[id]
      price = articles.price
      quantity = articles.count

      const vouchers = state.vouchers
      for (const voucherGroup in vouchers) {
        for (const voucherIndex in vouchers[voucherGroup]) {
          if (vouchers[voucherGroup][voucherIndex].id === parseInt(id)) {
            variant = vouchers[voucherGroup][voucherIndex].text

            if (voucherGroup === 'hamburg') {
              name = 'Voucher Hamburg Dungeon'
              tid = 'wv.du-'
            } else if (voucherGroup === 'hafenrundfahrt') {
              name = 'Voucher Hafenrundfahrt'
              tid = 'wv.hr-'
            } else if (voucherGroup === 'stadtrundfahrt') {
              name = 'Voucher Stadtrundfahrt'
              tid = 'wv.sr-'
            }

            taxRate = vouchers[voucherGroup][voucherIndex].tax_rate
          }
        }
      }

      tid = tid + id
      category = 'Tickets/Vouchers'
    } else if (type === 'event') {
      articles = state.cart.events.articles[id]
      name = `Ticket ${state.articles[id]?.text_de}`
      variant = state.articles[id]?.unterbezeichnung_de
      category = 'Tickets/Events/Regular'
      taxRate = state.articles[id].mwst
      tid = `wt.e-${id}`
      gap = state.cart.events.gap
      date = state.cart.events.date
      price = articles.price
      quantity = articles.count

      if (gap === GAP_GIFT_CARD) {
        name = `Geschenkgutschein ${state.articles[id].text_de}`
        category = 'Tickets/Events/Gift Certificates'
        tid = `wg.e-${id}`
      }
    } else {
      return false
    }

    const prod = {
      name: name,
      variant: variant,
      category: category,
      id: tid,
      price: price,
      taxRate: taxRate * 100,
      quantity: quantity
    }

    if (gap) {
      prod.gap = gap
    }

    if (date) {
      prod.date = date
    }

    if (list) {
      prod.list = list
    }

    if (position) {
      prod.position = position
    }

    return prod
  },

  /**
   * return [ <Product> ]
   */
  makeCart (state) {
    const eetCart = []

    if (state.isReservation) {
      const prod = {
        name: 'Ticket',
        variant: 'Reservierung',
        category: 'Tickets/Regular/Reservation',
        id: 'wt.r',
        quantity: state.cart.reservations.count,
        date: state.cart.reservations.date,
        gap: state.cart.reservations.gap
      }

      eetCart.push(prod)
    } else {
      this.cycleCart(state.cart.tickets.articles, 'ticket', state, eetCart)
      this.cycleCart(state.cart.events.articles, 'event', state, eetCart)
      this.cycleCart(state.cart.vouchers.articles, 'voucher', state, eetCart)
    }

    return eetCart
  },

  cycleCart (articles, type, state, eetCart) {
    for (const aId in articles) {
      const prod = this.makeProduct(aId, type, state)
      if (prod !== false) {
        eetCart.push(prod)
      }
    }
  }

}
